import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AppSteps, StepsManagementService } from '../../shared/services/steps-management.service';

export const manualUrlNavigationGuard: CanActivateFn = (route) => {
  const stepsManagementService = inject(StepsManagementService);

  if (stepsManagementService.isStepLocked(route.routeConfig?.path)) {
    stepsManagementService.navigateToStep(AppSteps.TripDetails);
    return false;
  }

  return true;
};
